import { useState } from "react";
import api from "@/lib/api";

/**
 * Re-enter password before a sensitive action.
 * Usage:
 *   <ReauthModal title="Confirm admin password reset"
 *                onCancel={...}
 *                onConfirmed={(pw) => doThing(pw)} />
 * The parent decides what to do with the verified password: either call its
 * dedicated endpoint that re-takes current_password, or do nothing (if
 * /auth/reauth success is enough).
 */
export default function ReauthModal({ title = "Confirm your password", onCancel, onConfirmed, submitLabel = "Confirm" }) {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  async function go(e) {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/reauth", { password: pw });
      onConfirmed?.(pw);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Password incorrect");
    } finally { setBusy(false); }
  }
  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" data-testid="reauth-modal">
      <form onSubmit={go} className="card max-w-md w-full">
        <h3 className="text-silver mb-3">{title}</h3>
        <label className="block text-sm text-silver mb-1">Current password</label>
        <input type="password" autoComplete="current-password" className="input mb-3"
               value={pw} onChange={e=>setPw(e.target.value)} autoFocus data-testid="reauth-pw"/>
        {err && <div className="text-red-500 text-sm mb-2" data-testid="reauth-err">{err}</div>}
        <div className="flex gap-2 justify-end">
          <button type="button" className="btn-ghost" onClick={onCancel} data-testid="reauth-cancel">Cancel</button>
          <button className="btn-silver" disabled={busy || !pw} data-testid="reauth-confirm">
            {busy ? "Checking…" : submitLabel}
          </button>
        </div>
      </form>
    </div>
  );
}
